import { get, post, patch, httpDelete, download } from '../axiosReq'

//获取用户显示及检查设置
export const get_user_config_api = params => post('/qeda/symbols/get_user_config/', params)

//显示及检查设置
export const set_user_config_api = params => post('/qeda/symbols/settings_config/', params)